import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'

import { OrderPipe } from 'ngx-order-pipe'
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

import { Processo } from 'src/app/models/processo.model'

import { ProfileService } from 'src/app/shared/profile.service'
import { LoginService } from 'src/app/shared/login.service'
import { NotificationService } from 'src/app/shared/notification.service'

import { ProcessoService } from './processos.service'

@Component({
	selector: 'app-processos',
	templateUrl: './processos.component.html',
	styleUrls: ['./processos.component.scss'],
})
export class ProcessosComponent implements OnInit, OnDestroy {
	title = 'PROCESSOS'
	dynamicUrl = '/processos'

	processo: Processo = new Processo()
	processos: Array<Processo> = []
	processosFilter: Array<Processo> = []

	dataSaved = false

	responsavel_valiaProcesso = ['Arrecadação', 'Cadastro', 'Beneficios', 'Empréstimos']

	infoMessage = { status: 0, message: '' }

	createProcessoForm: FormGroup
	updateProcessoForm: FormGroup
	deleteProcessoForm: FormGroup

	closeResult: string
	modalRef: NgbModalRef
	modalOptions: NgbModalOptions

	_listFilter: string
	filtered: Array<Processo> = []

	// paginação
	page = 1
	pageSize = 15
	collectionSize: number
	pagefiltered: Array<Processo> = []
	order: string = 'nome'
	key: string = 'nome'
	reverse: boolean = false
	onSort(key) {
		this.key = key
		this.reverse = !this.reverse
	}

	perfilNormativo = false
	perfilTecnico = false
	loginDisplay = false

	private subscriptions: Subscription[] = []

	constructor(
		private processoService: ProcessoService,
		private orderPipe: OrderPipe,
		private formBuilder: FormBuilder,
		private modalService: NgbModal,
		private perfilService: ProfileService,
		private loginService: LoginService,
		private notificationService: NotificationService
	) {
		this.createForm()
		this.updateForm()
		this.deleteForm()

		this.orderPipe.transform(this.processos, this.order)
		this.orderPipe.transform(this.pagefiltered, this.order)
	}

	ngOnInit(): void {
		this.subscriptions.push(
			this.loginService.user$.subscribe((user) => {
				this.loginDisplay = !!user
				if (user) {
					this.perfilService.verificarPerfis() // Verifica os perfis assim que o usuário é logado
					this.carregarPerfis()
				}
				this.getProcessos()
			}),
			this.loginService.error$.subscribe((error) => {
				this.infoMessage.message = error || ''
			})
		)
	}

	carregarPerfis() {
		this.perfilNormativo = this.perfilService.getPerfilNormativo()
		this.perfilTecnico = this.perfilService.getPerfilTecnico()
	}

	resetPage() {
		this.getProcessos()
		this.createForm()
		this.updateForm()
		this.deleteForm()
	}

	get listFilter(): string {
		return this._listFilter
	}

	set listFilter(value: string) {
		this.filtered = this.processos
		this._listFilter = value
		this.filtered = this.listFilter ? this.onFilter(this.listFilter) : this.processos
		this.collectionSize = this.filtered.length
		this.pagefiltered = this.filtered

		this.refreshPage()
	}

	onFilter(text: string): Array<Processo> {
		return this.processos.filter((processo) => {
			const term = text.toLowerCase()
			return processo.nome.toLowerCase().includes(term) || processo.descricao.toLowerCase().includes(term)
		})
	}

	refreshPage() {
		this.pagefiltered = this.listFilter
			? this.filtered
					.map((processo, i) => ({ index: i + 1, ...processo }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
			: this.processos
					.map((processo, i) => ({ index: i + 1, ...processo }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
	}

	cleanFiltered() {
		this.collectionSize = this.processos.length
		this.listFilter = ''
		this.refreshPage()
	}

	getProcessos() {
		this.infoMessage.status = 2
		this.processoService.getProcessos().subscribe((res) => {
			if (res.status >= 400) {
				this.notificationService.showMessage(res.status, res.statusText, 'read', this.dynamicUrl)
			} else {
				if (res._count == 0) {
					this.infoMessage = { status: 1, message: 'Não existem processos cadastrados!' }
				} else {
					this.infoMessage.status = 3
					this.processos = res.processos
					this.processosFilter = this.processos
					this.collectionSize = this.processos.length
					this.refreshPage()
				}
			}
		})
	}

	onChange(event, form) {
		if (event.target.value) form.responsavel_valia = event.target.value
	}

	createForm() {
		this.createProcessoForm = this.formBuilder.group({
			nome: new FormControl('', [Validators.required]),
			descricao: new FormControl('', [Validators.required]),
			responsavel_valia: new FormControl('', [Validators.required]),
		})
	}

	onCreate(processo: Processo) {
		this.processoService.create(processo).subscribe(
			(res) => {
				this.dataSaved = true
				this.createProcessoForm.reset()
				if (res.error === undefined) {
					this.notificationService.showMessage(res.status, 'Registro criado com sucesso.', 'create', this.dynamicUrl)
          this.onDismiss()
				} else {
					this.notificationService.showMessage(res.status, res.error, 'create', this.dynamicUrl)
				}
			},
			(error) => {
				this.notificationService.showMessage(error, error.messsage, 'create', this.dynamicUrl)
			}
		)
	}

	update(processo: Processo, form) {
		this.openModal(form)
		this.updateProcessoForm.patchValue({
			id: processo.id,
			descricao: processo.descricao,
			nome: processo.nome,
			responsavel_valia: processo.responsavel_valia,
		})
		this.processo = processo
		this.filtered = this.processos
		this.cleanFiltered()
	}

	updateForm() {
		this.updateProcessoForm = this.formBuilder.group({
			id: new FormControl(''),
			nome: new FormControl('', [Validators.required]),
			descricao: new FormControl('', [Validators.required]),
			responsavel_valia: new FormControl('', [Validators.required]),
		})
	}

	onUpdate(form) {
		let processo = JSON.parse(JSON.stringify(form.value))
		this.processoService.update(processo).subscribe(
			(res) => {
        console.log(res, ' update')
				if (res.status === 'OK') {
					this.notificationService.showMessage(res.status, res.mensagem, 'update', this.dynamicUrl)
          this.onDismiss()
				} else {
					this.notificationService.showMessage(res.status, res.message, 'update', this.dynamicUrl)
				}
			},
			(error) => {
				this.notificationService.showMessage(error, error.message, 'update', this.dynamicUrl)
			}
		)
	}

	delete(processo: Processo, form) {
		this.openModal(form)
		this.deleteProcessoForm.patchValue({
			id: processo.id,
			nome: processo.nome,
			descricao: processo.descricao,
			responsavel_valia: processo.responsavel_valia,
		})
		this.processo = processo
		this.cleanFiltered()
	}

	deleteForm() {
		this.deleteProcessoForm = this.formBuilder.group({
			id: [{ value: '', disabled: true }],
			nome: [{ value: '', disabled: true }],
			descricao: [{ value: '', disabled: true }],
			responsavel_valia: [{ value: '', disabled: true }],
		})
	}

	onDelete(form: any) {
		this.processo = JSON.parse(JSON.stringify(form.value))
		this.processoService.delete(this.processo).subscribe(
			(res: any) => {
				this.notificationService.showMessage(res.status, res.mensagem, 'delete', this.dynamicUrl)
				this.onDismiss()
			},
			(error) => {
				this.notificationService.showMessage(error, error.message, 'delete', this.dynamicUrl)
			}
		)
	}

	openModal(form) {
		this.modalRef = this.modalService.open(form)
		this.modalRef.result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`
			}
		)
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'Pressione ESC para sair'
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'Click OK para executar a tarefa'
		} else {
			return `with: ${reason}`
		}
	}

  onDismiss() {
		this.modalRef.dismiss()
		this.cleanFiltered()
		this.getProcessos()
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
